/**
 * Created by shubham on 20/10/18.
 */

import { Component, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { HttpService } from '../shared/services/http.service';
import { SessionHandler } from '../shared/services/session-handler.service';
import { DatatableComponent } from '@swimlane/ngx-datatable';
import { MdDialog } from '@angular/material';
import { DialogComponent } from '../dialog/dialog.component';
import { CommonService } from '../shared/services/common.service';
import { FormGroup, FormBuilder } from '@angular/forms';
import { ApplicationsPage } from "./applications-datatable/applications-page";
import { APPCONFIG } from '../config';
import { ApplicationsManagerDashboardResultService } from '../applicationsManagerDashboardResultService';
import { ApplicationRejectActionDialogComponent } from '../dialog/dialog.component';
import {TranslateService} from 'ng2-translate';

@Component({
    selector: 'applications-manager-dashboard',
    template: require('./applications-manager-dashboard.component.html'),
    styles: [require('../../app/newCommon.scss')],
})
export class ApplicationsManagerDashboardComponent {

    @ViewChild(DatatableComponent) table: DatatableComponent;
    page = new ApplicationsPage();
    applicationText: any;
    dialogRef;
    userDetails: any;
    isSystemAdmin: boolean = false;
    isApplicationManager: boolean = false;
    isBUManager: boolean = false;
    isRegionalAdmin: boolean = false;
    isServiceOwner: boolean = false;
    isTradePartner: boolean = false;
    isSubUser: boolean = false;
    tableRows: any = [];
    rows: any;
    filters: any = {};
    ApplicationsFiltersForm: FormGroup;
    applicationsName = [];
    selectedApplicationId: string = '';
    isDisabled = false;
    selected = [];
    selectedStatusId: string = '';
    selectedCount: any;
    count: any;
    totalCount: any;
    searchedFilters = { applicationName: '', wpassId: '' };
    showCheckbox = false;
    applicationsDashboardData = [];
    temp = [];
    showTable: boolean = true;
    Wpass: Array<any> = [];
    autocompleteLoader: string = "";
    searchWpass:string = "";
    countries =[];
    businessUnits = [];
    tempCountries =[{
        "id": "",
        "name": "all",
        "code": "",
        "active": true,
        "createdAt": "2019-02-26T12:49:39.329Z"
    }];
    tempBusinessUnits = [{
        "id": "",
        "name": "all",
        "codeISAM": "",
        "active": true,
        "createdAt": "2018-04-06T20:05:02.397Z",
        "updatedAt": "2018-05-31T06:41:54.303Z"
    }];
    selectedCountryId:any = "";
    selectedBusinessUnit:any = "";
    dataTableMessage = {'selectedMessage':'','totalMessage':''};
    StatusData = [{
        "id": "",
        "code": "",
        "name": "all"
    }];

    constructor(private router: Router, private httpService: HttpService, private sessionHandler: SessionHandler, public dialog: MdDialog,
        private formBuilder: FormBuilder, private serverResultsService: ApplicationsManagerDashboardResultService, private commonService: CommonService, 
        private translate: TranslateService) {

        //Close Sidebar Initially
        APPCONFIG.navCollapsed = true;

        this.page.pageNumber = 0;
        this.page.size = 20;
        this.applicationText = 'applicationManagerView';

        this.userDetails = JSON.parse(this.sessionHandler.getItem('loginData'));
        if (this.userDetails && Object.keys(this.userDetails).length > 0 && this.userDetails.roleCode && this.userDetails.roleCode.length > 0) {
            if (this.userDetails.roleCode.includes(APPCONFIG.systemAdmin)) {
                this.isSystemAdmin = true;
            }
            if (this.userDetails.roleCode.includes(APPCONFIG.applicationManager)) {
                this.isApplicationManager = true;
            }
            if (this.userDetails.roleCode.includes(APPCONFIG.BUManager)) {
                this.isBUManager = true;
            }
            if (this.userDetails.roleCode.includes(APPCONFIG.regionalAdmin)) {
                this.isRegionalAdmin = true;
            }
            if (this.userDetails.roleCode.includes(APPCONFIG.serviceOwner)) {
                this.isServiceOwner = true;
            }
            if (this.userDetails.roleCode.includes(APPCONFIG.tradePartner)) {
                this.isTradePartner = true;
            }
            if (this.userDetails.roleCode.includes(APPCONFIG.subuser)) {
                this.isSubUser = true;
            }
        } else {
            this.httpService.noUserError();
        }

        this.filters['offSet'] = this.page.pageNumber * this.page.size;
        this.filters['limit'] = this.page.size;
        if (this.isBUManager || this.isRegionalAdmin || this.isApplicationManager || this.isSystemAdmin) {
            this.getCountries();
            this.getBusinessUnitAll();
            this.getStatusList();
            this.getApplicationsName();
            this.getApplicationsList(this.filters, this.selectedStatusId, this.selectedApplicationId, this.searchWpass, this.selectedBusinessUnit, this.selectedCountryId);
        } else {
            this.showTable = false;
        }

        //Call when approve/delete from ApproveRejectComponent/ActiveInactiveComponent to get the updated list.
        this.commonService.applicationDashboard.subscribe((value) => {
            this.getApplicationsList(this.filters, this.selectedStatusId, this.selectedApplicationId, this.searchWpass, this.selectedBusinessUnit, this.selectedCountryId);
        });
    }

    /*buildForm() {
        this.ApplicationsFiltersForm = this.formBuilder.group({
            wpassId: this.formBuilder.control(''),
        });
        this.ApplicationsFiltersForm.valueChanges.subscribe(data => {
            this.wpassId = this.ApplicationsFiltersForm.get('wpassId').value;
        });
    }*/
    public getCountries(){
        this.httpService.getRequest('lookupDataOperationsApi/v1/countriesForAdmin').subscribe(
            res => { this.saveCountries(res); },
            err => { this.httpService.onEnd(); }
        );
    }

    public saveCountries(res){
        if(res && res.items){
            this.countries = this.tempCountries.concat(res.items);
        }
    }

    onCountryChange(countryId){
        //this.businessUnits = [];
        this.businessUnits = this.tempBusinessUnits;
        if(countryId != ""){
            this.selectedBusinessUnit = "";
            this.getBusinessUnitForCountry(countryId);
        } else{
            this.getBusinessUnitAll();
        }
    }
    public getBusinessUnitForCountry(countryId) {
        this.httpService.getRequestWithoutLoader('lookupDataOperationsApi/v1/buForSelectedCountry/'+countryId).subscribe(
            res => { this.saveBusinessUnitForCountry(res); },
            err => { this.httpService.onEnd(); }
        );
    }

    saveBusinessUnitForCountry(res) {
        if(res && res.items){
            //this.businessUnits = res.items;
            this.businessUnits = this.tempBusinessUnits.concat(res.items);
        }
        this.httpService.onEnd();
    }
   
    public getBusinessUnitAll() {
        this.httpService.getRequestWithoutAuth('lookupDataOperationsApi/v1/businessUnit', true).subscribe(
            res => { this.saveBusinessUnitAll(res); },
            err => { this.httpService.onEnd(); }
        );
    }

    saveBusinessUnitAll(res) {
        if(res && res.items){
            this.businessUnits = this.tempBusinessUnits.concat(res.items);
            this.httpService.onEnd();
        }
    }

    autocompleteSearch(term: string, filter: string) {

        if (filter == "wpass") {
            this.Wpass = [];
            this.searchWpass = term;
        }

        if (term == "") return;

        let url = "/lookupDataOperationsApi/v1/partialSearch?type=" + filter + "&searchStr=" + term;
        this.autocompleteLoader = filter;
        this.httpService.getRequestForAutocomplete(url).subscribe(
            res => {
                if (res && res['items']) {
                    let name = res['items'];
                    let filterArray = [];

                    for (let index in name) {
                        filterArray.push(name[index]['name']);
                    }

                    if (filter == "wpass") {
                        this.Wpass = filterArray;
                    }
                }
                this.autocompleteLoader = "";
                this.httpService.onEnd();
            },
            err => {
                this.autocompleteLoader = "";
                this.httpService.onEnd();
            })
    }

    onSelectAutocomplete(value, textFlag) {
        if (textFlag == "wpass") {
            this.searchWpass = value;
        }
    }
  
   
    public search() {
        this.selected = [];
        this.filters['offSet'] = 0;

        if (this.searchWpass == undefined) {
            this.searchWpass = "";
        } else if(this.searchWpass != "" && this.Wpass.length > 0){
            if(this.checkAutocompleteWord(this.Wpass, this.searchWpass)){
                this.searchWpass = "";
            }
        }

        this.getApplicationsList(this.filters, this.selectedStatusId, this.selectedApplicationId, this.searchWpass, this.selectedBusinessUnit, this.selectedCountryId);
    }

    public resetSearch() {
        /*this.ApplicationsFiltersForm.controls['wpassId'].enable();
        this.ApplicationsFiltersForm.reset();*/
        this.selectedApplicationId = "";
        this.searchWpass = '';
        this.selectedStatusId = "";
        this.Wpass = [];
        this.countries = [];
        this.businessUnits = [];
        this.selectedBusinessUnit = "";
        this.selectedCountryId = "";
        this.getCountries();
        this.getBusinessUnitAll();
        this.search();
    }

    checkAutocompleteWord(objArray, searchValue){
        if(objArray.includes(searchValue)){
            return false;
        } else {
            return true;
        }
    }


    public getStatusList() {
        this.httpService.getRequest("applicationOperationApi/v1/getApplicationStatusList").subscribe(
            res => { this.saveStatusList(res); },
            err => { this.httpService.onEnd(); }
        );
    }
    public saveStatusList(res) {
        if (res) {
            if (res.items) {
                for (let s in res.items) {
                    this.StatusData.push(res.items[s]);
                }
            }
        }
    }

    public getApplicationsName() {
        this.httpService.getRequest("applicationOperationApi/v1/applicationsForDropdown").subscribe(
            res => { this.saveApplicationsName(res); },
            err => { this.httpService.onEnd(); }
        );
    }
    public saveApplicationsName(res) {
        if (res && res.items) {
            var tempApp =[{"id": "", "code": "", "name": "all" }];
            this.applicationsName = tempApp.concat(res.items);
        }
    }

    public getApplicationsList(filter, selectedStatus, applicationId, wpassId, selectedBusinessUnit, selectedCountryId) {

        this.searchedFilters.wpassId = wpassId;

        if (selectedStatus == 'PENDING' && applicationId != '') {
            this.showCheckbox = true;
        } else {
            this.showCheckbox = false;
        }

        this.httpService.getRequest("/applicationOperationApi/v1/applicationRequestsForManager?limit=" + filter.limit + "&offset=" + filter.offSet + "&status=" + selectedStatus + "&applicationId=" + applicationId + "&wpassId=" + wpassId+"&businessUnitId="+selectedBusinessUnit+"&countryId="+selectedCountryId).subscribe(
            res => { this.saveApplicationsList(res, filter); },
            err => { this.httpService.onEnd(); }
        );
    }

    public saveApplicationsList = function (res, filter) {

        if (res.errorStatus == 'Fail') {
            this.httpService.onEnd();
            this.dialogRef = this.dialog.open(DialogComponent);
            this.dialogRef.componentInstance.msg = 'data_pull_fail';
        } else {
            if (res && Object.keys(res).length > 0) {
                this.applicationsDashboardData = res;
                this.rows = [];
                this.rows['offset'] = res.offset;
                this.count = res.count;
                this.totalCount = res.totalCount;

                if (this.applicationsDashboardData.list) {
                    let totalCount = 0;
                    if (parseInt(res.offset) == 0) {
                        localStorage.setItem('totalCount', res.totalCount);
                        totalCount = parseInt(res.totalCount);
                    } else {
                        totalCount = parseInt(localStorage.getItem('totalCount'));
                    }

                    this.rows['totalCount'] = totalCount;
                    for (let data in this.applicationsDashboardData.list) {
                        if (this.isBUManager || this.isRegionalAdmin || this.isApplicationManager || this.isSystemAdmin) {
                            this.rows[data] = {};
                            this.rows[data]['id'] = this.applicationsDashboardData.list[data]['id'];
                            this.rows[data]['applicationId'] = this.applicationsDashboardData.list[data]['applicationId'];
                            this.rows[data]['applicationName'] = this.applicationsDashboardData.list[data]['applicationName'];

                            if (this.applicationsDashboardData.list[data]['applicationRoles'] && Object.keys(this.applicationsDashboardData.list[data]['applicationRoles']).length > 0) {
                                let multipleApplicationRoles = [];
                                for (let roles in this.applicationsDashboardData.list[data]['applicationRoles']) {
                                    if (this.applicationsDashboardData.list[data]['applicationRoles'][roles]['roleName']) {
                                        multipleApplicationRoles.push(this.applicationsDashboardData.list[data]['applicationRoles'][roles]);
                                        this.rows[data]['applicationRoles'] = multipleApplicationRoles;
                                    } else { this.rows[data]['applicationRoles'] = null; }
                                }
                            } else {
                                this.rows[data]['applicationRoles'] = null;
                            }

                            if (this.applicationsDashboardData.list[data]['userId_WPASS']) {
                                this.rows[data]['userId_WPASS'] = this.applicationsDashboardData.list[data]['userId_WPASS'];
                            } else {
                                this.rows[data]['userId_WPASS'] = null;
                            }

                            this.rows[data]['businessUnitId'] = this.applicationsDashboardData.list[data]['businessUnitId'];
                            this.rows[data]['businessUnitName'] = this.applicationsDashboardData.list[data]['businessUnitName'];
                            this.rows[data]['countryId'] = this.applicationsDashboardData.list[data]['countryId'];
                            this.rows[data]['countryName'] = this.applicationsDashboardData.list[data]['countryName'];

                            if (this.applicationsDashboardData.list[data]['approverId']) {
                                this.rows[data]['approverId'] = this.applicationsDashboardData.list[data]['approverId'];
                                this.rows[data]['approverName'] = this.applicationsDashboardData.list[data]['approverName'];
                            } else {
                                this.rows[data]['approverId'] = null;
                                this.rows[data]['approverName'] = null;
                            }

                            this.rows[data]['multipleRole'] = this.applicationsDashboardData.list[data]['multipleRole'];

                            if (this.applicationsDashboardData.list[data]['reason']) {
                                this.rows[data]['reason'] = this.applicationsDashboardData.list[data]['reason'];
                            } else {
                                this.rows[data]['reason'] = null;
                            }

                            this.rows[data]['status'] = this.applicationsDashboardData.list[data]['status'];
                            this.rows[data]['statusCode'] = this.applicationsDashboardData.list[data]['statusCode'];
                            this.rows[data]['updatedAt'] = this.applicationsDashboardData.list[data]['updatedAt'];
                        } else {
                            //For Other Service Partner's
                            this.rows[data] = {};
                        }
                    }
                    this.showTable = true;
                    this.temp = this.rows;
                } else {
                    this.showTable = false;
                }

                let finalRows = [];
                for (let f in this.rows) {
                    if (f != 'offset' && f != 'totalCount' && this.rows[f]) {
                        finalRows.push(this.rows[f]);
                    }
                    if (f == 'offset') {
                        finalRows['offset'] = this.rows['offset'];
                    }
                    if (f == 'totalCount') {
                        finalRows['totalCount'] = this.rows['totalCount'];
                    }
                }
                this.rows = finalRows;
                this.setPage({ offset: this.rows['offset'] / this.page.size }, finalRows, filter);
                this.httpService.onEnd();
            }
        }
    }

    /**
     * Populate the table with new data based on the page number
     * @param page The page to select
     */
    public setPage(pageInfo, rows, filter) {
        this.page.pageNumber = pageInfo.offset;
        if (rows.length != 0) {
            this.serverResultsService.getResults(this.page, rows).subscribe(pageData => {
                this.page = pageData.page;
                this.tableRows = pageData.data;
                if (!filter) {
                    if (Object.keys(this.tableRows).length == 0 || !this.tableRows[0]['status']) {
                        this.filters['offSet'] = this.page.pageNumber * this.page.size;


                        this.getApplicationsList(this.filters, this.selectedStatusId, this.selectedApplicationId, this.searchWpass, this.selectedBusinessUnit, this.selectedCountryId);
                    }
                }
            });
        } else {
            this.tableRows = [];
            this.page.totalElements = rows.length;
        }
    }

    rejectAction(id, status) {
        this.dialogRef = this.dialog.open(ApplicationRejectActionDialogComponent);
        this.dialogRef.componentInstance.isRejected = true;
        this.dialogRef.componentInstance.msg = 'rqst_rjct_confirm';
        this.dialogRef.afterClosed().subscribe(result => {
            if (result) {
                let data = {};
                data['id'] = id;
                data['status'] = status;
                data['message'] = result;

                let today = new Date();
                let dd = ('0' + today.getDate()).slice(-2);
                let mm = ('0' + (today.getMonth() + 1)).slice(-2);
                let yyyy = today.getFullYear();
                data['approvalDate'] = yyyy + '' + mm + '' + dd;

                this.httpService.postRequest(data, 'applicationOperationApi/v1/approveApplicationRequest').subscribe(
                    res => {
                        this.saveResponse(res, status);
                    },
                    err => {
                        this.httpService.onEnd();
                    }
                );
            }
        });
    }
    public saveResponse(res, status) {
        this.httpService.onEnd();
        let statusTxt;
        if (res) {
            if (status == 'REJECTED') {
                statusTxt = 'Rejected Successfully';
            }
            this.dialogRef = this.dialog.open(DialogComponent);
            this.dialogRef.componentInstance.msg = statusTxt;
            this.dialogRef.afterClosed().subscribe(result => {
                this.getApplicationsList(this.filters, this.selectedStatusId, this.selectedApplicationId, this.searchWpass, this.selectedBusinessUnit, this.selectedCountryId);
            });
        }
    }

    onSelect({ selected }) {
        this.selected.splice(0, this.selected.length);
        this.selected.push(...selected);
        this.selectedCount = this.selected.length;
    }
    downloadCsv(){
        let loginDataArray = JSON.parse(this.sessionHandler.getItem("loginData"));
        let accessToken;

        if(loginDataArray){
            accessToken  = loginDataArray['accessToken'];
        }
        window.open(APPCONFIG.URL+'/export?access-token='+accessToken+'&action=application_requests&status='+this.selectedStatusId+'&applicationId='+this.selectedApplicationId+'&wpassId='+this.searchWpass+'&businessUnitId='+this.selectedBusinessUnit+'&countryId='+this.selectedCountryId,'_blank')

    }
    saveRevokeData(id){
            this.dialogRef = this.dialog.open(DialogComponent);
            this.dialogRef.componentInstance.isConfirm = true;
            this.dialogRef.componentInstance.msg = "app_revoke_confirm";
            this.dialogRef.afterClosed().subscribe(result => {
                if (result) {
                    var user_application_id = {id: id}
                    this.httpService.postRequest(user_application_id,'applicationOperationApi/v1/revokeAllApplicationRoles').subscribe(
                        res => {
                            this.dialogRef = this.dialog.open(DialogComponent);
                            this.dialogRef.componentInstance.msg = "request_success";
                            this.httpService.onEnd();
                        },
                        err => { this.httpService.onEnd(); 
                                    this.dialogRef = this.dialog.open(DialogComponent);
                                    this.dialogRef.componentInstance.msg = "request_failed";
                                    this.httpService.onEnd();
                        }
                    );
                    
                }
               
            });
        
    }

    /* saveApplicationDataApi(){
        this.httpService.postRequest(this.ApplicationsRequestFormDetails,'applicationOperationApi/v1/updateUserApplicationRoles').subscribe(
            res => {
                this.saveApplicationResponse(res);
            },
            err => { this.httpService.onEnd(); }
        );
    } */

    ngOnInit() {
        //this.buildForm();
        this.translate.get('total').subscribe((res: string) => {
            this.dataTableMessage.totalMessage=res;
        });
        this.translate.get('selected').subscribe((res: string) => {
            this.dataTableMessage.selectedMessage=res;
        });
    }

    ngOnDestroy() {
        this.dialog.closeAll();
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/applications-manager-dashboard/applications-manager-dashboard.component.ts